import FileUploadInfo from './container/FileUploadInfo';

export default FileUploadInfo;



// WEBPACK FOOTER //
// ./src/views/FileUploadInfo/index.js